import { OUTGOING_SESSION, OUTGOING_SESSION_SUCCESS, OUTGOING_SESSION_ERROR, OUTGOING_SESSION_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const OutgoingSession = (state = initialState, action) => {
  switch (action.type) {
    case OUTGOING_SESSION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case OUTGOING_SESSION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case OUTGOING_SESSION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case OUTGOING_SESSION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default OutgoingSession;
